<yo-adding-area-ligne-parametrage
  [selectedTypeFactureClient]="TypeFactureClientEnum.FACTURE_CLIENT_FAMILLE_FACTURATION"
  (onNewLigneParametrage)="this.retrieveNewLigneParametrage($event)">
</yo-adding-area-ligne-parametrage>

<yo-ligne-parametrage-famille-facturation-data-grid
  #grid
  class="grid-container"
  [lignes]="ligneParametrageFamilleFactuList"
  (onFilter)="this.loadData($event)">
  <div data-position="left">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      label="CRÉER"
      tooltip="Créer un nouveau paramétrage"
      iconClass="fa fa-plus"
      (onClick)="expandAddArea()">
    </yo-button>
  </div>

  <div data-position="right" class="custom-button-container">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier les lignes de paramétrage sélectionnées"
      iconClass="fa fa-edit"
      [disabled]="!isRowSelected()"
      (onClick)="openModificationPopup()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier les périodes de prix"
      iconClass="fa fa-calendar"
      [disabled]="!isRowSelected()"
      (onClick)="openPeriodePrixPopup()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.SAVE"
      iconClass="fa fa-save"
      tooltip="Enregistrer les lignes de paramétrage"
      [disabled]="!gridChanges.hasChanges()"
      (onClick)="save()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DELETE_INNER"
      iconClass="fa fa-trash"
      tooltip="Supprimer les lignes de paramétrage sélectionnées"
      [disabled]="!isRowSelected()"
      (onClick)="delete()">
    </yo-button>
  </div>
</yo-ligne-parametrage-famille-facturation-data-grid>

<dx-popup
  title="Paramétrage des éléments à facturer"
  [visible]="isEditLinesPopupDisplayed"
  width="1200"
  height="700"
  minWidth="600"
  resizeEnabled="true"
  (onHiding)="closeEditLinesPopup()">
  <div class="full-size">
    <yo-ligne-parametrage-famille-facturation-data-grid
      #gridPopup
      class="grid-container"
      [lignes]="ligneToAddList"
      (onFilter)="this.loadData($event)">
      <div data-position="right" class="custom-button-container">
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier les lignes de paramétrage sélectionnées"
          iconClass="fa fa-edit"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openModificationPopup()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier les périodes de prix"
          iconClass="fa fa-calendar"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openPeriodePrixPopup()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.SAVE"
          iconClass="fa fa-save"
          tooltip="Enregistrer les lignes de paramétrage"
          [disabled]="!canAddValues()"
          (onClick)="saveEditedLines()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DELETE_INNER"
          iconClass="fa fa-trash"
          tooltip="Supprimer les lignes de paramétrage sélectionnées"
          [disabled]="!isPopupRowSelected()"
          (onClick)="delete()">
        </yo-button>
      </div>
    </yo-ligne-parametrage-famille-facturation-data-grid>
  </div>
</dx-popup>

<dx-popup
  title="Modification de masse"
  [visible]="isModificationPopupDisplayed"
  width="auto"
  height="auto"
  minWidth="600"
  (onHiding)="closeModificationPopup()">
  <div class="dialog-line">
    <div class="label">Famille de facturation</div>
    <div class="value">
      <yo-lookup
        [data]="familleFacturationList"
        [selectedItem]="selectedFamilleFacturation"
        autoSelect="false"
        (onValueChange)="updateFamilleFacturation($event)"
        placeholder="Sélectionner la famille de facturation ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Élément facturable</div>
    <div class="value">
      <yo-lookup
        [data]="elementFacturableList"
        [selectedItem]="selectedElementFacturable"
        autoSelect="false"
        (onValueChange)="updateElementFacturable($event)"
        placeholder="Sélectionner l'élément facturable ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Taxe</div>
    <div class="value">
      <yo-lookup
        [data]="taxeList"
        [selectedItem]="selectedTaxe"
        [displayValue]="getTaxeDisplayValue"
        autoSelect="false"
        (onValueChange)="updateTaxe($event)"
        placeholder="Sélectionner la taxe ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        (onClick)="applyModifications()">
      </yo-button>
    </div>
  </div>
</dx-popup>
<dx-popup
  title="Période de prix"
  [visible]="isPeriodePrixPopupDisplayed"
  width="auto"
  height="auto"
  minWidth="600"
  (onHiding)="closePeriodePrixPopup()">
  <div class="dialog-line">
    <div class="label">Prix de vente HT</div>
    <div class="value">
      <dx-number-box
        [(value)]="selectedPrix"
      placeholder="Prix de vente HT">
      </dx-number-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Taux de revalorisation</div>
    <div class="value">
      <dx-number-box
        [(value)]="selectedTaux"
        placeholder="Taux en %">
      </dx-number-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>A partir de</span>
    </div>
    <div class="value">
      <yo-date-picker
        [value]="dateSelected"
        (onValueChange)="onChangeDate($event)">
      </yo-date-picker>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        (onClick)="applyPeriodePrix()">
      </yo-button>
    </div>
  </div>
</dx-popup>
